import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';

@Component({
  selector: 'app-parents-layout',
  templateUrl: './parents-layout.component.html',
  styleUrls: ['./parents-layout.component.scss']
})
export class ParentsLayoutComponent implements OnInit {

  constructor(public auth: AuthService) { }

  ngOnInit(): void {
  }

}
